"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartSetup = void 0;
const config_1 = require("./config");
const cartSetup = (options) => {
    const alreadySetup = Boolean(window.__Commerce);
    if (!alreadySetup) {
        setupScript(options);
    }
    return window.__Commerce.setupPromise;
};
exports.cartSetup = cartSetup;
const setupScript = (options) => {
    const { cartUrl } = config_1.getConfig(options.env || 'local');
    const embedScriptId = 'commerce-cart-script';
    const frameOptions = Object.assign(Object.assign({}, options), { cartUrl });
    window.__Commerce = {
        setupPromise: createSetupPromise(),
        options: frameOptions
    };
    const embedScript = document.createElement('script');
    embedScript.src = `${frameOptions.cartUrl}/dist/embed.js`;
    embedScript.async = true;
    embedScript.id = embedScriptId;
    document.body.appendChild(embedScript);
};
const createSetupPromise = () => {
    let externalResolve;
    let externalReject;
    const setupPromise = new Promise((resolve, reject) => {
        externalResolve = resolve;
        externalReject = reject;
    });
    setupPromise.resolve = externalResolve;
    setupPromise.reject = externalReject;
    return setupPromise;
};
//# sourceMappingURL=index.js.map